import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAffiliateDashboardCardsApi, getanalyticstrends, getanalyticsCards, getAffiliateBadges, getAnalyticsGraph, getAnalyticsperformance } from "../../Api/AffiliateApiCall";
// import { getAdminDashboardCardsApi, getAffiliateuserlist } from "../../Api/AdminApiCall";

export const fetchAffiliateDashboardCards = createAsyncThunk(
    "affiliate/fetchAffiliateDashboardCards",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getAffiliateDashboardCardsApi();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAnalyticsTrends = createAsyncThunk(
    "affiliate/fetchAnalyticsTrends",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getanalyticstrends();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAnalyticsCards = createAsyncThunk(
    "affiliate/fetchAnalyticsCards",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getanalyticsCards();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAffiliateBadges = createAsyncThunk(
    "affiliate/fetchAffiliateBadges",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getAffiliateBadges();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAnalyticsGraph = createAsyncThunk(
    "affiliate/fetchAnalyticsGraph",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await getAnalyticsGraph(filter);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchAnalyticPerformance = createAsyncThunk(
    "affiliate/fetchAnalyticPerformance",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getAnalyticsperformance();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);


const AffiliateSlice = createSlice({
    name: "affiliateDashboard",
    initialState: {
        AffiliateDashboards: [],
        Analytictrends: [],
        AnalyticsCardsdata: [],
        AffiliateBadges: [],
        AnalyticsPerformance: [],

        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffiliateDashboardCards.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateDashboardCards.fulfilled, (state, action) => {
                state.loading = false;
                state.AffiliateDashboards = action.payload;
            })
            .addCase(fetchAffiliateDashboardCards.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAnalyticsTrends.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsTrends.fulfilled, (state, action) => {
                state.loading = false;
                state.Analytictrends = action.payload;
            })
            .addCase(fetchAnalyticsTrends.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAnalyticsCards.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsCards.fulfilled, (state, action) => {
                state.loading = false;
                state.AnalyticsCardsdata = action.payload;
            })
            .addCase(fetchAnalyticsCards.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAffiliateBadges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateBadges.fulfilled, (state, action) => {
                state.loading = false;
                state.AffiliateBadges = action.payload;
            })
            .addCase(fetchAffiliateBadges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAnalyticsGraph.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsGraph.fulfilled, (state, action) => {
                state.loading = false;
                state.AnalyticsGraphdata = action.payload;
            })
            .addCase(fetchAnalyticsGraph.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAnalyticPerformance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticPerformance.fulfilled, (state, action) => {
                state.loading = false;
                state.AnalyticsPerformance = action.payload;
            })
            .addCase(fetchAnalyticPerformance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

const AffiliateDashboardReducer = AffiliateSlice.reducer;

export default AffiliateDashboardReducer;
